<ion-content>
  <section *ngIf="!isTouch">
    <ion-icon
      name="close-outline"
      class="close-button"
      (click)="dismissPopover()"
    ></ion-icon>
    <ng-container [ngTemplateOutlet]="checkReferenceImg"> </ng-container>
  </section>
  <section *ngIf="isTouch" class="swiper-section">
    <swiper-container zoom="true">
      <swiper-slide>
        <div class="swiper-zoom-container">
          <ng-container [ngTemplateOutlet]="checkReferenceImg"> </ng-container>
        </div>
      </swiper-slide>
    </swiper-container>
  </section>
</ion-content>
<ng-template #checkReferenceImg>
  <img
    class="check-reference-img"
    src="../../../../../assets/images/check-image-{{ imageDetail }}.svg"
    alt="check image"
  />
</ng-template>
